// @flow

export const getSpanishTaxAreas = () => [
  { value: '01', label: 'Andalucía' },
  { value: '02', label: 'Aragón' },
  { value: '03', label: 'Asturias' },
  { value: '04', label: 'Canarias' },
  { value: '05', label: 'Cantabria' },
  { value: '06', label: 'Castilla - La Mancha' },
  { value: '07', label: 'Castilla y León' },
  { value: '08', label: 'Cataluña' },
  { value: '09', label: 'Extremadura' },
  { value: '10', label: 'Galicia' },
  { value: '11', label: 'Illes Balears' },
  { value: '12', label: 'La Rioja' },
  { value: '13', label: 'Madrid' },
  { value: '14', label: 'Murcia' },
  { value: '15', label: 'Valencia' },
  { value: '16', label: 'Diputación Foral de Navarra' },
  { value: '17', label: 'Diputación Foral de Álava' },
  { value: '18', label: 'Diputación Foral de Guipúzcoa' },
  { value: '19', label: 'Diputación Foral de Vizcaya' },
  { value: '20', label: 'Ceuta' },
  { value: '21', label: 'Melilla' },
  //  { value: '22', label: 'Not resident' },
];
